<template>
  <el-dialog center width="600px" :title="dialogTitle" :visible.sync="dialogFormVisible" @close="resetFrom('editForm')">
    <el-form :model="editForm" :rules="editRules" ref="editForm">
      <el-form-item label="升级版本" :label-width="formLabelWidth" prop="version">
        <el-input v-model="editForm.version" autocomplete="off"></el-input>
      </el-form-item>

      <el-form-item label="发布时间" :label-width="formLabelWidth" prop="publishTime">
        <el-date-picker v-model="editForm.publishTime" type="date"  autocomplete="off"></el-date-picker>
      </el-form-item> 

<el-form-item label="下载地址" :label-width="formLabelWidth" prop="href">
        <el-input v-model="editForm.href" autocomplete="off"></el-input>
      </el-form-item>

      <el-form-item label="升级内容" :label-width="formLabelWidth" prop="remark">
        <el-input v-model="editForm.remark" type="textarea" :rows="2" autocomplete="off"></el-input>
      </el-form-item>

     <el-form-item label="客户端类型" :label-width="formLabelWidth" prop="type">
        <el-select v-model="editForm.type" placeholder="请选择">
          <el-option
            v-for="item in globalStatus"
                  :key="item.type"
                  :label="item.name"
                  :value="item.type">
          </el-option>
        </el-select>
      </el-form-item>

    </el-form>    

    <div slot="footer" class="dialog-footer">
      <el-button @click="resetFrom('editForm');dialogFormVisible = false;">取 消</el-button>
      <el-button type="primary" @click="submitEdit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { formData, formRules} from '../form.js'
import { appAdd, appEdit } from "@/api/appPublishApi.js"
export default {
  name: 'editForm',
  data() {
    return {
      publishId: '',
      dialogTitle: '',
      dialogFormVisible: false,
      editForm: {...formData},
      editRules: formRules,
      formLabelWidth: "120px",
      globalStatus : [{
          type : 0,
          name : '安卓'
        },
        {
          type : 1,
          name : '苹果'
        }
      ]
    };
  },
  inject: ['reload'],
  computed: {

  },  
  props: [
    
  ],  
  mounted() {
  },
  methods: {
    resetFrom(){
      this.editForm = {}
    }, 
    submitEdit() {
      try {
        this.$refs.editForm.validate(async valid => {
        if(!valid) return this.$message.error("格式不对哦，检查一下呗!")
        
        if(this.publishId != ''){
          await appEdit(this.publishId, {...this.editForm}).then(res => {
            if(res.code === 200){
              this.$message.success("编辑成功!")
            }
            else{
              this.$message.success("编辑失败!")
              return;
            }
          });
        }
        else{
          await appAdd({...this.editForm}).then(res => {
            if(res.code === 200){
              this.$message.success("新增成功!")
            }
            else{
              this.$message.success("新增失败!")
              return;
            }
          });
        }
        this.dialogFormVisible = false
        this.editForm = {}
        // 重新获取数据
        this.reload()
     
      }); 
     } catch (e) {
       window.console.log(e)
     }
    }
  }
};
</script>

<style></style>
